import fetchAPI, { IHttpError } from '../../../lib/utils/fetch-api'
import {
  setMeasurementId,
  setMeasurementEnumsData,
  setMeasurementEnumsFailed,
  setMeasurementEnumsLoading,
  setMeasurementFormData,
  setMeasurementFormFailed,
  setMeasurementFormLoading,
} from './actions'
import { handleStageConflictResponse } from '../../lib/stage-conflict'

export function getMeasurementForm(id) {
  return async dispatch => {
    dispatch(setMeasurementFormLoading())
    try {
      const response = (await fetchAPI(`/api/measurement/${id}`)) || []
      if (response['errors'] || response?.error) {
        let error = response['errors'] || response?.error
        if (Array.isArray(error)) {
          error = error.join()
        }
        return dispatch(setMeasurementFormFailed(error))
      }
      if (response?.redirect) {
        return response.redirect as string
      }
      return dispatch(setMeasurementFormData(response))
    } catch (err) {
      console.error(err)
      const message = (err as IHttpError)?.message || 'При загрузки полей возникла ошибка'
      const statusCode = (err as IHttpError)?.statusCode || 'error'
      return dispatch(setMeasurementFormFailed({ message, statusCode }))
    }
  }
}

export function nextStage(id, formData) {
  return async dispatch => {
    dispatch(setMeasurementFormLoading())
    try {
      const response = await fetchAPI(`/api/measurement/${id}`, {
        method: 'POST',
        body: JSON.stringify(formData),
      })

      if (handleStageConflictResponse(response, () => dispatch(getMeasurementForm(id)))) {
        return
      }

      if (response['errors']) {
        let error = response['errors']
        if (Array.isArray(error)) {
          error = error.join()
        }
        return dispatch(setMeasurementFormFailed(error))
      }
      return dispatch(setMeasurementFormData(response))
    } catch (err) {
      return dispatch(setMeasurementFormFailed(err as string))
    }
  }
}

export function updateFormData(id, formData) {
  return async dispatch => {
    try {
      const response = await fetchAPI(`/api/measurement/${id}`, {
        method: 'POST',
        body: JSON.stringify(formData),
      })

      if (response['errors']) {
        let error = response['errors']
        if (Array.isArray(error)) {
          error = error.join()
        }
        return dispatch(setMeasurementFormFailed(error))
      }

      if (response?.id) {
        return dispatch(setMeasurementId(response.id))
      }

      return
    } catch (err) {
      return dispatch(setMeasurementFormFailed(err as string))
    }
  }
}

export function getMeasurementEnums(id: string) {
  return async dispatch => {
    dispatch(setMeasurementEnumsLoading())
    try {
      const response = await fetchAPI(`/api/measurement/${id}/enum`)

      if (response['errors']) {
        let error = response['errors']
        if (Array.isArray(error)) {
          error = error.join()
        }
        return dispatch(setMeasurementEnumsFailed(error))
      }

      return dispatch(setMeasurementEnumsData(response))
    } catch (err) {
      console.error(err)
      return dispatch(setMeasurementEnumsFailed('При загрузке enum возникла ошибка'))
    }
  }
}
